import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import Icon from '../base_svg-icon/component';
import store from '@utils/store';

import './styles/style.scss';

class FilterRange extends Component {
  constructor(props) {
    super(props);
    this.state = {
      minIsValid: true,
      maxIsValid: true,
      value: {
        min: '',
        max: '',
      },
      initiatedChange: {
        min: false,
        max: false,
      },
    };

    this.minRef = createRef();
    this.maxRef = createRef();
  }

  get originalMax() {
    return Number(this.props.max) || 1000;
  }

  get originalMin() {
    return Number(this.props.min) || 1;
  }

  get validInput() {
    const min = Number(this.minRef.current.value || 0);
    const max = Number(this.maxRef.current.value || Math.ceil(this.originalMax));
    const minIsValid = (min < max && min >= 0);
    const maxIsValid = (max > min && max > 0);
    this.setState({ minIsValid, maxIsValid });
    return {
      minIsValid,
      maxIsValid,
    };
  }

  componentDidUpdate(prevProps) {
    const { min: rangeMin, max: rangeMax, filter } = this.props;
    if (prevProps.min !== rangeMin || prevProps.max !== rangeMax) {
      this.setState({
        value: {
          min: '',
          max: '',
        },
        minIsValid: true,
        maxIsValid: true,
      });
    } else if (prevProps.filter !== filter) {
      this.setState({
        value: {
          min: '',
          max: '',
        },
        initiatedChange: {
          min: false,
          max: false,
        },
      });
    }
  }

  inputOnChangeHandler = (e)  => {
    const { name, value } = e.target;
    const reset = (name === 'min') ? { minIsValid: true } : { maxIsValid: true };
    this.setState({
      ...reset,
      value: {
        ...this.state.value,
        [name]: value ? Number(value) : '',
      },
      initiatedChange: {
        ...this.state.initiatedChange,
        [name]: true,
      },
    });
  };


  /**
   * Submit filter
   */
  submitFilter = () => {
    const { minIsValid, maxIsValid } = this.validInput;
    if ((minIsValid && maxIsValid) && this.props.callBack) {
      this.props.callBack({
        min: Number(this.minRef.current.value || 0),
        max: Number(this.maxRef.current.value || Math.ceil(this.originalMax)),
        currentMin: Number(this.minRef.current.value || this.originalMin || 0),
        currentMax: Number(this.maxRef.current.value || Math.ceil(this.originalMax)),
      });
      store.modal.closeModal();
    }
  };

  /**
   * Trigger submit on enter
   */
  handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      this.submitFilter();
    }
  };

  /**
   * Render the range input fields
   * @returns {HTMLElement[]}
   */
  renderRangeInputFields() {
    const { maxIsValid, minIsValid, value, initiatedChange } = this.state;
    const { selectedMin = '', selectedMax = '' } = this.props;
    const { min, max } = value;

    return (
      <div className="manual-range-input">
        <div className="price-input">
          <input
            ref={this.minRef}
            min={Math.floor(this.originalMin)}
            max={Math.ceil(this.originalMax)}
            onChange={this.inputOnChangeHandler}
            onKeyDown={this.handleKeyDown}
            type="number"
            className={`sliderMinValue form-control ${!minIsValid ? 'invalid' : ''}`}
            value={initiatedChange.min ? min : selectedMin}
            placeholder={`${Math.floor(this.originalMin)}`}
            name="min"
            data-test-id="input-minValue"
          />
        </div>
        <div className="price-separator">tot</div>
        <div className="price-input">
          <input
            ref={this.maxRef}
            min={Math.floor(this.originalMin)}
            max={Math.ceil(this.originalMax)}
            onChange={this.inputOnChangeHandler}
            onKeyDown={this.handleKeyDown}
            type="number"
            className={`sliderMaxValue form-control ${!maxIsValid ? 'invalid' : ''}`}
            value={initiatedChange.max ? max : selectedMax}
            placeholder={`${Math.ceil(this.originalMax)}`}
            name="max"
            data-test-id="input-maxValue"
          />
        </div>
        <div className="unique-submit" onClick={this.submitFilter} data-test-id="submit-valueSlider">
          <Icon size={200} name="ico-arrow-circle-right"/>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className="filter-range-container">
        {this.renderRangeInputFields()}
      </div>
    );
  }
}

FilterRange.propTypes = {
  callBack: PropTypes.func.isRequired,
  selectedMax: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  selectedMin: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  min: PropTypes.number,
  max: PropTypes.number,
  filter: PropTypes.string,
};

export default FilterRange;

